import { ScramjetClient } from "@client/index";

export default function (client: ScramjetClient, _self: Self) {
	client.Trap("origin", {
		get() {
			// TODO: this isn't right!! (a blank frame's is its creator's: meta.origin)
			return client.meta.origin.origin;
		},
		set() {
			return false;
		},
	});
}
